import { ref } from 'vue';

export function useBrowserDetection() {
  const isSafari = ref(false);

  // Chrome has 'Safari' string in userAgent prop
  if (typeof navigator !== 'undefined') {
    const ua = navigator.userAgent;
    isSafari.value = /Safari/.test(ua) && !/Chrome/.test(ua);
  }

  return { isSafari };
}
